import React, { useEffect, useRef, useState } from 'react';
import L from 'leaflet';
import { useAuth } from '../../context/AuthContext';
import {
  fetchDistrictsApi,
  fetchYardsApi,
  createYardApi,
  updateYardApi,
  deleteYardApi,

  fetchPointControlsByYardApi,
  updatePointControlApi,
  createPointControlBatchApi,
  deletePointControlApi,
  
  GetPerimeterYard,
} from '../../services/api';
import PerimeterModal from '../../components/PerimeterModal';

export default function PatiosClean() {
  const { tenantId, token } = useAuth();
  const [rows, setRows] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [form, setForm] = useState({ nombre: '', distrito: '', districtId: '', direccion: '', lat: '', lng: '' });
  const [showMap, setShowMap] = useState(false);
  const [showPoints, setShowPoints] = useState(false);
  const [pointsYard, setPointsYard] = useState({ id: null, name: '', lat: null, lng: null });

  const [showPerimeter, setShowPerimeter] = useState(false);
  const [perimeterYard, setPerimeterYard] = useState({ id: null, name: '', lat: null, lng: null });


  const [districts, setDistricts] = useState([]);
  const [districtsLoading, setDistrictsLoading] = useState(true);
  const [districtsError, setDistrictsError] = useState('');

  const [toasts, setToasts] = useState([]);
  const toast = (type, msg) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, type, msg }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 4000);
  };
  const [confirmTarget, setConfirmTarget] = useState(null); // { id, nombre, distrito }

  const reload = async () => {
    const list = await fetchYardsApi({ token });
    setRows(list);
  };

  useEffect(() => { (async () => { try { await reload(); } catch { } })(); }, [token]);

  useEffect(() => {
    let active = true;
    (async () => {
      setDistrictsLoading(true);
      try {
        const list = await fetchDistrictsApi({ token });
        if (!active) return;
        list.sort((a, b) => String(a.name).localeCompare(String(b.name)));
        setDistricts(list);
      } catch { setDistrictsError('No se pudieron cargar distritos'); }
      finally { if (active) setDistrictsLoading(false); }
    })();
    return () => { active = false; };
  }, [token]);

  const openCreate = () => { setEditingId(null); setForm({ nombre: '', distrito: '', districtId: '', direccion: '', lat: '', lng: '' }); setShowForm(true); };
  const openEdit = (r) => { setEditingId(r.id); setForm({ nombre: r.nombre, distrito: r.distrito, districtId: r.districtId || '', direccion: r.direccion, lat: r.lat, lng: r.lng }); setShowForm(true); };

  const saveForm = async (e) => {
    e.preventDefault();
    const { nombre, districtId, direccion, lat, lng } = form;
    if (!nombre || !districtId) return;
    try {
      if (editingId == null) {
        const res = await createYardApi({ tenantId, districtId, name: nombre, address: direccion || '', latitude: lat || 0, longitude: lng || 0, token });
        const ok = !!(res?.isSuccess || res?.value);
        if (ok) {
          toast('success', 'Patio creado correctamente');
        } else {
          throw new Error(res?.message || 'No se pudo registrar');
        }
      } else {
        const res = await updateYardApi({ id: editingId, districtId, name: nombre, address: direccion || '', latitude: lat || 0, longitude: lng || 0, token });
        const ok = !!(res?.isSuccess || res?.value);
        if (ok) {
          toast('success', 'Patio modificado correctamente');
        } else {
          throw new Error(res?.message || 'No se pudo modificar');
        }
      }
      setShowForm(false);
      await reload();
    } catch (err) { toast('danger', err.message || 'Error al registrar'); }
  };

  const removeRow = async (id) => { try { await deleteYardApi({ id, token }); await reload(); toast('success', 'Eliminado correctamente'); } catch (e) { toast('danger', e?.message || 'No se pudo eliminar'); } };

  return (
    <div className="container-fluid">
      <div className="mb-2"><h2 className="mb-2 text-center">Patios</h2></div>

      <div className="gp-toast-container">
        {toasts.map(t => (
          <div key={t.id} className={`toast align-items-center text-bg-${t.type} show`} role="alert">
            <div className="d-flex"><div className="toast-body">{t.msg}</div><button type="button" className="btn-close btn-close-white me-2 m-auto" onClick={() => setToasts(prev => prev.filter(x => x.id !== t.id))} /></div>
          </div>
        ))}
      </div>

      <div className="mb-3 d-flex gap-2 justify-content-end">
        <button className="btn btn-primary" title="Registrar" onClick={openCreate}><i className="bi bi-plus-lg" /></button>
        <button className="btn btn-outline-secondary" title="Actualizar" onClick={reload}><i className="bi bi-arrow-clockwise" /></button>
      </div>

      <div className="card"><div className="table-responsive">
        <table className="table table-hover align-middle mb-0">
          <thead className="table-light"><tr>
            <th style={{ width: 140 }}>Acciones</th>
            <th>Nombre</th><th>Dirección</th><th>Coordenadas</th><th>Distrito</th>
          </tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={5} className="text-center text-muted py-4">Sin registros</td></tr>}
            {rows.map(r => (
              <tr key={r.id}>
                <td>
                  <div className="btn-group btn-group-sm">
                    <button className="btn btn-outline-danger" onClick={() => setConfirmTarget({ id: r.id, nombre: r.nombre, distrito: r.distrito })} title="Eliminar"><i className="bi bi-trash" /></button>
                    <button className="btn btn-outline-primary" onClick={() => openEdit(r)} title="Modificar"><i className="bi bi-pencil" /></button>
                    <button className="btn btn-outline-warning" onClick={() => { setPointsYard({ id: r.id, name: r.nombre, lat: r.lat ?? r.latitude ?? null, lng: r.lng ?? r.longitude ?? null }); setShowPoints(true); }} title="Puntos de control"><i className="bi bi-broadcast" /></button>
                    <button
                      className="btn btn-outline-success"
                      title="Perímetro"
                      onClick={() => {
                        setPerimeterYard({
                          id: r.id,                             // requerido para el payload
                          lat: r.lat ?? r.latitude ?? null,     // opcional (solo para centrar el mapa)
                          lng: r.lng ?? r.longitude ?? null     // opcional
                        });
                        setShowPerimeter(true);
                      }}
                    >
                      <i className="bi bi-bounding-box-circles" />
                    </button>
                  </div>
                </td>
                <td>{r.nombre}</td>
                <td>{r.direccion}</td>
                <td>{(r.lat != null && r.lng != null) ? `${Number(r.lat).toFixed(6)}, ${Number(r.lng).toFixed(6)}` : ''}</td>
                <td>{r.distrito}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div></div>

      {/* Modal formulario */}
      <div className={`modal fade ${showForm ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" aria-modal={showForm}>
        <div className="modal-dialog modal-dialog-centered"><div className="modal-content">
          <form onSubmit={saveForm}>
            <div className="modal-header"><h5 className="modal-title">{editingId == null ? 'Registrar Patio' : 'Modificar Patio'}</h5>
              <button type="button" className="btn-close" onClick={() => setShowForm(false)} />
            </div>
            <div className="modal-body">
              <div className="mb-3"><label className="form-label">Nombre</label>
                <input className="form-control" value={form.nombre} onChange={e => setForm({ ...form, nombre: e.target.value })} required />
              </div>
              <div className="mb-3"><label className="form-label">Distrito</label>
                <DistrictSelect disabled={districtsLoading} options={districts} value={{ id: form.districtId, name: form.distrito }} onChange={(opt) => setForm({ ...form, distrito: opt.name, districtId: opt.id })} />
                {districtsError && <div className="small text-danger mt-1">{districtsError}</div>}
              </div>
              <div className="mb-3"><label className="form-label">Dirección</label>
                <div className="input-group">
                  <input className="form-control" value={form.direccion} placeholder="Seleccione en el mapa" disabled readOnly />
                  <button type="button" className="btn btn-outline-primary" onClick={() => setShowMap(true)}><i className="bi bi-geo-alt" /></button>
                </div>
                <div className="form-text">Lat: {form.lat || '—'} · Lng: {form.lng || '—'}</div>
              </div>
            </div>
            <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>Cancelar</button>
              <button type="submit" className="btn btn-primary">Guardar</button></div>
          </form>
        </div></div>
      </div>
      {showForm && <div className="modal-backdrop fade show" onClick={() => setShowForm(false)} />}

      <MapModal show={showMap} onClose={() => setShowMap(false)} onConfirm={(lat, lng, address) => { setForm(f => ({ ...f, lat, lng, direccion: address })); setShowMap(false); }} />
      {showMap && <div className="modal-backdrop fade show" onClick={() => setShowMap(false)} />}

      <PointsModal show={showPoints} yardId={pointsYard.id} yardName={pointsYard.name} centerLat={pointsYard.lat} centerLng={pointsYard.lng} token={token} onClose={() => setShowPoints(false)} onToast={toast} />
      {showPoints && <div className="modal-backdrop fade show" onClick={() => setShowPoints(false)} />}

      {/* Confirmación de eliminación */}
      <div className={`modal fade ${confirmTarget ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" aria-modal={!!confirmTarget}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Confirmación</h5>
              <button type="button" className="btn-close" onClick={() => setConfirmTarget(null)} />
            </div>
            <div className="modal-body">
              {`¿Esta seguro que desea eliminar ${confirmTarget?.nombre ?? ''} ubicado en ${confirmTarget?.distrito ?? ''}?`}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => setConfirmTarget(null)}>No</button>
              <button type="button" className="btn btn-danger" onClick={async () => { const id = confirmTarget.id; setConfirmTarget(null); await removeRow(id); }}>Sí, eliminar</button>
            </div>
          </div>
        </div>
      </div>
      {confirmTarget && <div className="modal-backdrop fade show" onClick={() => setConfirmTarget(null)} />}

      {/* Modal de perimetros*/}
      <PerimeterModal
        show={showPerimeter}
        yardId={perimeterYard.id}
        centerLat={perimeterYard.lat}
        centerLng={perimeterYard.lng}
        token={token}
        onClose={() => setShowPerimeter(false)}
        onToast={toast}
      />

      {showPerimeter && <div className="modal-backdrop fade show" onClick={() => setShowPerimeter(false)} />}

    </div>
  );
}

function DistrictSelect({ options, value, onChange, disabled }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const ref = useRef(null);
  useEffect(() => { const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }; document.addEventListener('mousedown', h); return () => document.removeEventListener('mousedown', h); }, []);
  const list = q ? options.filter(d => String(d.name).toLowerCase().includes(q.toLowerCase())) : options;
  const label = value?.name || 'Seleccione…';
  return (
    <div className="dropdown w-100" ref={ref}>
      <button type="button" className="btn btn-light w-100 border d-flex justify-content-between align-items-center" onClick={() => !disabled && setOpen(v => !v)} disabled={disabled}>
        <span className="text-truncate">{label}</span><i className="bi bi-caret-down-fill" />
      </button>
      {open && (
        <div className="dropdown-menu show w-100 p-2" style={{ maxHeight: 260, overflow: 'auto' }}>
          <input className="form-control form-control-sm mb-2" placeholder="Buscar distrito" value={q} onChange={e => setQ(e.target.value)} autoFocus />
          {list.length ? list.map(d => (
            <button key={d.id ?? d.name} type="button" className="dropdown-item" onClick={() => { onChange({ id: d.id, name: d.name }); setOpen(false); }}>{d.name}</button>
          )) : <div className="text-muted small px-2">Sin resultados</div>}
        </div>
      )}
    </div>
  );
}

function MapModal({ show, onClose, onConfirm }) {
  const mapRef = useRef(null);
  const mapObj = useRef(null);
  const markerRef = useRef(null);
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [pending, setPending] = useState({ lat: null, lng: null, address: '' });
  useEffect(() => {
    if (!show) return; if (mapRef.current && !mapObj.current) {
      mapObj.current = L.map(mapRef.current).setView([-12.0464, -77.0428], 12);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; OpenStreetMap contributors' }).addTo(mapObj.current);
      mapObj.current.on('click', async (e) => {
        const { lat, lng } = e.latlng; placeOrMove(lat, lng);
        const address = await reverseGeocode(lat, lng); setPending({ lat, lng, address });
      });
    }
  }, [show]);
  const placeOrMove = (lat, lng) => { if (!mapObj.current) return; if (!markerRef.current) { markerRef.current = L.circleMarker([lat, lng], { radius: 8, color: '#0d6efd', fillColor: '#0d6efd', fillOpacity: 0.8 }).addTo(mapObj.current); } else { markerRef.current.setLatLng([lat, lng]); } mapObj.current.setView([lat, lng], 16); };
  const reverseGeocode = async (lat, lng) => { try { const res = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`, { headers: { 'Accept-Language': 'es' } }); const data = await res.json(); return data.display_name || `Lat ${lat.toFixed(6)}, Lng ${lng.toFixed(6)}`; } catch { return `Lat ${lat.toFixed(6)}, Lng ${lng.toFixed(6)}`; } };
  const doSearch = async (e) => { e.preventDefault(); if (!query.trim()) return; try { const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=5`, { headers: { 'Accept-Language': 'es' } }); const data = await res.json(); setResults(data); if (data[0]) { const lat = parseFloat(data[0].lat), lon = parseFloat(data[0].lon); placeOrMove(lat, lon); } } catch { setResults([]); } };
  return (
    <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" aria-modal={show}>
      <div className="modal-dialog modal-lg modal-dialog-centered"><div className="modal-content">
        <div className="modal-header"><h5 className="modal-title">Seleccionar ubicación</h5><button type="button" className="btn-close" onClick={onClose} /></div>
        <div className="modal-body">
          <form className="mb-2" onSubmit={doSearch}><div className="input-group">
            <input className="form-control" placeholder="Buscar dirección o lugar" value={query} onChange={e => setQuery(e.target.value)} />
            <button className="btn btn-outline-primary" type="submit"><i className="bi bi-search" /></button>
          </div></form>
          {results.length > 0 && (<div className="list-group mb-2" style={{ maxHeight: 140, overflow: 'auto' }}>
            {results.map((r, i) => (<button key={i} type="button" className="list-group-item list-group-item-action" onClick={() => { const lat = parseFloat(r.lat), lon = parseFloat(r.lon); placeOrMove(lat, lon); }}>{r.display_name}</button>))}
          </div>)}
          <div ref={mapRef} style={{ height: 360, borderRadius: 8, overflow: 'hidden' }} />
          <div className="small text-muted mt-2">{pending.address ? (<>
            Selección: {pending.address}<br />Lat: {pending.lat?.toFixed(6)} · Lng: {pending.lng?.toFixed(6)}
          </>) : 'Haz clic en el mapa o usa la búsqueda.'}</div>
        </div>
        <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
          <button type="button" className="btn btn-primary" disabled={!pending.address} onClick={() => onConfirm(pending.lat.toFixed(6), pending.lng.toFixed(6), pending.address)}>OK</button></div>
      </div></div>
    </div>
  );
}

function PointsModal({ show, yardId, yardName, centerLat, centerLng, token, onClose, onToast }) {
  const mapRef = useRef(null);
  const mapObj = useRef(null);
  const layerRef = useRef(null);
  const [existing, setExisting] = useState([]);
  const [perimeter, setPerimeter] = useState([]);
  const [pending, setPending] = useState([]);
  const [radiusPreset, setRadiusPreset] = useState(10);
  const [editingPointId, setEditingPointId] = useState(null);
  const [editingPendingIndex, setEditingPendingIndex] = useState(null);
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);

  useEffect(() => { if (!show) return; (async () => { try { const pts = await fetchPointControlsByYardApi(yardId, { token }); setExisting(pts); } catch { onToast?.('danger', 'No se pudieron cargar puntos'); } })(); }, [show, yardId, token]);

  useEffect(() => {
    if (!show) return;
    if (!yardId) {
      setPerimeter([]);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const data = await GetPerimeterYard({ yardId, token });
        if (cancelled) return;
        const coords = Array.isArray(data)
          ? data
              .slice()
              .sort((a, b) => (Number(a?.order) || 0) - (Number(b?.order) || 0))
              .map(p => [Number(p.latitude), Number(p.longitude)])
              .filter(([lat, lng]) => Number.isFinite(lat) && Number.isFinite(lng))
          : [];
        setPerimeter(coords);
      } catch (err) {
        // console.error(err);
        if (!cancelled) setPerimeter([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [show, yardId, token]);

  useEffect(() => {
    if (!show) return;
    if (mapRef.current && !mapObj.current) {
      const initLat = (typeof centerLat === 'number' ? centerLat : parseFloat(centerLat));
      const initLng = (typeof centerLng === 'number' ? centerLng : parseFloat(centerLng));
      const hasCenter = !isNaN(initLat) && !isNaN(initLng);
      mapObj.current = L.map(mapRef.current).setView(hasCenter ? [initLat, initLng] : [-12.0464, -77.0428], hasCenter ? 16 : 15);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { attribution: '&copy; OpenStreetMap contributors' }).addTo(mapObj.current);
      layerRef.current = L.layerGroup().addTo(mapObj.current);
      mapObj.current.on('click', (e) => {
        if (editingPointId != null || editingPendingIndex != null) return;
        const { lat, lng } = e.latlng;
        const idx = existing.length + pending.length;
        setPending(prev => [...prev, { id: null, yardId, name: `p${idx}`, location: `p${idx}`, latitude: lat, longitude: lng, geozoneRadio: radiusPreset, order: idx + 1 }]);
        // Entrar de inmediato a modo edición para arrastrar el nuevo punto
        try { setEditingPendingIndex(idx); } catch {}
      });
    } else if (show && mapObj.current) {
      // No recenter while editing a point or when there are pending points
      if (editingPointId != null || editingPendingIndex != null || (pending?.length ?? 0) > 0) return;
      const initLat = (typeof centerLat === 'number' ? centerLat : parseFloat(centerLat));
      const initLng = (typeof centerLng === 'number' ? centerLng : parseFloat(centerLng));
      if (!isNaN(initLat) && !isNaN(initLng)) {
        mapObj.current.setView([initLat, initLng], 16);
      }
    }
  }, [show, existing.length, pending.length, radiusPreset, yardId, editingPointId, editingPendingIndex, centerLat, centerLng]);

  // draw points (existing=green, pending=blue). If editingPointId or editingPendingIndex, show only that draggable (red)
  useEffect(() => {
    if (!mapObj.current || !layerRef.current) return;
    layerRef.current.clearLayers();
    if (perimeter.length >= 3) {
      const poly = L.polygon(perimeter, { color: '#0d6efd', weight: 2, fillColor: '#0dcaf0', fillOpacity: 0.1 });
      poly.addTo(layerRef.current);
    }
    const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    if (editingPointId != null) {
      const p = existing.find(x => x.id === editingPointId);
      if (!p) return;
      const icon = L.divIcon({ className: 'gp-marker-label', html: `<span><i class="bi bi-geo-alt-fill" style="color:#dc3545"></i> ${esc(p.location || p.name)}</span>` });
      const m = L.marker([p.latitude, p.longitude], { icon, draggable: true });
      const c = L.circle([p.latitude, p.longitude], { radius: Number(p.geozoneRadio) || 0, color: '#dc3545', fillColor: '#dc3545', fillOpacity: 0.15 });
      // Update circle live; commit position on dragend to avoid re-render during drag
      m.on('drag', (e) => { const { lat, lng } = e.latlng; c.setLatLng([lat, lng]); });
      m.on('dragend', (e) => { const { lat, lng } = e.target.getLatLng(); setExisting(prev => prev.map(pt => pt.id === p.id ? { ...pt, latitude: lat, longitude: lng } : pt)); });
      m.addTo(layerRef.current); c.addTo(layerRef.current); try { mapObj.current.panTo([p.latitude, p.longitude]); } catch {} return;
    }
    if (editingPendingIndex != null) {
      const p = pending[editingPendingIndex];
      if (!p) return;
      const icon = L.divIcon({ className: 'gp-marker-label', html: `<span><i class="bi bi-geo-alt-fill" style="color:#dc3545"></i> ${esc(p.location || p.name)}</span>` });
      const m = L.marker([p.latitude, p.longitude], { icon, draggable: true });
      const c = L.circle([p.latitude, p.longitude], { radius: Number(p.geozoneRadio) || 0, color: '#dc3545', fillColor: '#dc3545', fillOpacity: 0.15 });
      // Update circle live; commit position on dragend
      m.on('drag', (e) => { const { lat, lng } = e.latlng; c.setLatLng([lat, lng]); });
      m.on('dragend', (e) => { const { lat, lng } = e.target.getLatLng(); setPending(prev => prev.map((pt, i) => i === editingPendingIndex ? { ...pt, latitude: lat, longitude: lng } : pt)); });
      m.addTo(layerRef.current); c.addTo(layerRef.current); try { mapObj.current.panTo([p.latitude, p.longitude]); } catch {} return;
    }
    // existing (green)
    existing.forEach(p => { const icon = L.divIcon({ className: 'gp-marker-label', html: `<span><i class="bi bi-geo-alt-fill" style="color:#198754"></i> ${esc(p.location || p.name)}</span>` }); const m = L.marker([p.latitude, p.longitude], { icon }); const c = L.circle([p.latitude, p.longitude], { radius: Number(p.geozoneRadio) || 0, color: '#198754', fillColor: '#198754', fillOpacity: 0.15 }); m.addTo(layerRef.current); c.addTo(layerRef.current); m.bindPopup(`<b>${esc(p.name)}</b><br/>${Number(p.latitude).toFixed(6)}, ${Number(p.longitude).toFixed(6)}<br/>Radio: ${p.geozoneRadio}m`); });
    // pending (blue)
    pending.forEach(p => { const icon = L.divIcon({ className: 'gp-marker-label', html: `<span><i class="bi bi-geo-alt-fill" style="color:#0d6efd"></i> ${esc(p.location || p.name)}</span>` }); const m = L.marker([p.latitude, p.longitude], { icon }); const c = L.circle([p.latitude, p.longitude], { radius: Number(p.geozoneRadio) || 0, color: '#0d6efd', fillColor: '#0d6efd', fillOpacity: 0.15 }); m.addTo(layerRef.current); c.addTo(layerRef.current); m.bindPopup(`<b>${esc(p.name)}</b><br/>${Number(p.latitude).toFixed(6)}, ${Number(p.longitude).toFixed(6)}<br/>Radio: ${p.geozoneRadio}m`); });
    const layers = layerRef.current.getLayers();
    if (layers.length) {
      try {
        // Evitar que al crear un nuevo punto (click) el mapa cambie el zoom.
        // Solo ajustamos a los bounds cuando NO hay edición en curso y NO hay pendientes.
        if (editingPointId == null && editingPendingIndex == null && (pending?.length ?? 0) === 0) {
          const group = L.featureGroup(layers);
          mapObj.current.fitBounds(group.getBounds().pad(0.2));
        }
      } catch { }
    }
  }, [existing, pending, editingPointId, perimeter]);

  // Clean up pending/new points when modal closes
  useEffect(() => {
    if (!show) {
      setPending([]);
      setEditingPointId(null);
      setEditingPendingIndex(null);
      setQuery('');
      setResults([]);
      setPerimeter([]);
    }
  }, [show]);

  useEffect(() => { /* redraw when editingPendingIndex changes */
    if (editingPendingIndex != null) {
      // trigger draw effect
      const _ = pending;
    }
  }, [editingPendingIndex, pending]);

  // Asegurar que el índice de edición de pendientes siempre sea válido
  useEffect(() => {
    if (editingPendingIndex != null) {
      if (editingPendingIndex < 0 || editingPendingIndex >= pending.length) {
        setEditingPendingIndex(null);
      }
    }
  }, [pending.length]);

  const saveNew = async () => {
    try {
      if (!pending.length) return;
      const items = pending.map(p => ({
        yardId,
        name: p.name,
        location: p.location,
        latitude: p.latitude,
        longitude: p.longitude,
        geozoneRadio: Number(p.geozoneRadio) || 0,
        order: Number(p.order) || 0,
      }));
      const invalid = items.some(it => !(Number(it.geozoneRadio) > 0));
      if (invalid) { onToast?.('danger', 'El radio de geozona debe ser mayor a 0'); return; }
      await createPointControlBatchApi({ items, token });
      setPending([]);
      // salir de modo edición de pendiente si estaba activo
      setEditingPendingIndex(null);
      const pts = await fetchPointControlsByYardApi(yardId, { token });
      setExisting(pts);
      onToast?.('success', 'Puntos creados');
    } catch {
      onToast?.('danger', 'Error al crear puntos');
    }
  };
  const saveOneNew = async (idx) => {
    try {
      const p = pending[idx];
      if (!(Number(p.geozoneRadio) > 0)) { onToast?.('danger', 'El radio de geozona debe ser mayor a 0'); return; }
      await createPointControlBatchApi({ items: [{ yardId, name: p.name, location: p.location, latitude: p.latitude, longitude: p.longitude, geozoneRadio: Number(p.geozoneRadio) || 0, order: Number(p.order) || 0 }], token });
      setPending(prev => prev.filter((_, i) => i !== idx));
      // si estábamos editando este índice, salir del modo edición
      setEditingPendingIndex(prev => (prev == null ? null : (prev === idx ? null : (prev > idx ? prev - 1 : prev))));
      const pts = await fetchPointControlsByYardApi(yardId, { token });
      setExisting(pts);
      onToast?.('success', 'Punto creado');
    } catch {
      onToast?.('danger', 'Error al crear punto');
    }
  };
  const saveExisting = async (p) => { try { if (!(Number(p.geozoneRadio) > 0)) { onToast?.('danger', 'El radio de geozona debe ser mayor a 0'); return; } await updatePointControlApi({ id: p.id, yardId, name: p.name, location: p.location, latitude: p.latitude, longitude: p.longitude, geozoneRadio: Number(p.geozoneRadio) || 0, order: Number(p.order) || 0, token }); const pts = await fetchPointControlsByYardApi(yardId, { token }); setExisting(pts); onToast?.('success', 'Punto actualizado'); } catch { onToast?.('danger', 'Error al actualizar punto'); } };
  const deleteExisting = async (id) => { try { await deletePointControlApi({ id, token }); const pts = await fetchPointControlsByYardApi(yardId, { token }); setExisting(pts); onToast?.('success', 'Punto eliminado'); } catch { onToast?.('danger', 'Error al eliminar punto'); } };

  // search only when no points
  const doSearch = async (e) => { e.preventDefault(); if (!query.trim()) return; try { const res = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=8`, { headers: { 'Accept-Language': 'es' } }); const data = await res.json(); setResults(data); if (data[0]) { const lat = parseFloat(data[0].lat), lon = parseFloat(data[0].lon); mapObj.current.setView([lat, lon], 16); } } catch { setResults([]); } };

  return (
    <div className={`modal fade ${show ? 'show d-block' : ''}`} tabIndex="-1" role="dialog" aria-modal={show}>
      <div className="modal-dialog modal-fullscreen modal-dialog-centered"><div className="modal-content">
        <div className="modal-header mx-5"><h5 className="modal-title">Puntos de control · Patio {yardName || ('#' + yardId)}</h5><button type="button" className="btn-close" onClick={onClose} /></div>
        <div className="modal-body"><div className="row g-3">
          <div className="col-12 col-lg-8">
            {existing.length === 0 && (
              <form className="mb-2" onSubmit={doSearch}><div className="input-group">
                <input className="form-control" placeholder="Buscar dirección o lugar" value={query} onChange={e => setQuery(e.target.value)} />
                <button className="btn btn-outline-primary" type="submit"><i className="bi bi-search" /></button>
              </div>{results.length > 0 && (<div className="list-group mt-2" style={{ maxHeight: 120, overflow: 'auto' }}>
                {results.map((r, i) => (<button key={i} type="button" className="list-group-item list-group-item-action" onClick={() => { const lat = parseFloat(r.lat), lon = parseFloat(r.lon); mapObj.current.setView([lat, lon], 16); }}>{r.display_name}</button>))}
              </div>)}</form>
            )}
            <div className="mb-2 d-flex align-items-center gap-2"><label className="form-label mb-0">Radio por defecto (m)</label>
              <input type="number" min="0" className="form-control form-control-sm" style={{ width: 140 }} value={radiusPreset} onChange={e => setRadiusPreset(e.target.value)} />
              <span className="text-muted small">Clic en el mapa para agregar nuevos puntos</span>
            </div>
            <div ref={mapRef} style={{ height: '90vh', borderRadius: 8, overflow: 'hidden' }} />
          </div>
          <div className="col-12 col-lg-4">
            <div className="card mb-3"><div className="card-header py-2">Nuevos puntos</div>
              <div className="card-body p-2" style={{ maxHeight: 220, overflow: 'auto' }}>
                {pending.length === 0 && <div className="text-muted small">Sin nuevos puntos</div>}
                {pending.length > 0 && (
                  <div className="d-flex gap-2 text-muted small mb-1">
                    <div className="flex-fill">Nombre</div>
                    <div style={{ width: 90 }}>Alias</div>
                    <div style={{ width: 90 }}>Radio</div>
                    <div style={{ width: 90 }}>Orden</div>
                  </div>
                )}
                {pending.map((p, idx) => (
                  <div key={`new-${idx}`} className="border rounded p-2 mb-2">
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <input className="form-control form-control-sm" placeholder="Nombre" value={p.name} onChange={e => setPending(prev => prev.map((x, i) => i === idx ? { ...x, name: e.target.value } : x))} />
                      <input className="form-control form-control-sm" style={{ width: 90 }} placeholder="Alias" value={p.location} onChange={e => setPending(prev => prev.map((x, i) => i === idx ? { ...x, location: e.target.value } : x))} />
                      <input type="number" min={1} step={1} className="form-control form-control-sm" style={{ width: 80 }} placeholder="Radio (m)" value={p.geozoneRadio} onChange={e => setPending(prev => prev.map((x, i) => i === idx ? { ...x, geozoneRadio: e.target.value } : x))} />
                      <input type="number" step={1} className="form-control form-control-sm" style={{ width: 70 }} placeholder="Orden" value={p.order ?? ''} onChange={e => setPending(prev => prev.map((x, i) => i === idx ? { ...x, order: e.target.value } : x))} />

                      <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        title="Quitar"
                        onClick={() => {
                          setPending(prev => prev.filter((_, i) => i !== idx));
                          // ajustar/salir de modo edición de pendiente
                          setEditingPendingIndex(prev => (prev == null ? null : (prev === idx ? null : (prev > idx ? prev - 1 : prev))));
                        }}
                      >
                        <i className="bi bi-x-lg" />
                      </button>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      <input type="number" step="0.000001" className="form-control form-control-sm" style={{ width: 140 }} value={p.latitude} onChange={e => setPending(prev => prev.map((x, i) => i === idx ? { ...x, latitude: parseFloat(e.target.value) || 0 } : x))} />
                      <input type="number" step="0.000001" className="form-control form-control-sm" style={{ width: 140 }} value={p.longitude} onChange={e => setPending(prev => prev.map((x, i) => i === idx ? { ...x, longitude: parseFloat(e.target.value) || 0 } : x))} />
                    </div>
                  </div>
                ))}
              </div>
              <div className="card-footer py-2 text-end"><button className="btn btn-sm btn-primary" disabled={!pending.length} onClick={saveNew}>Guardar nuevos</button></div>
            </div>
            <div className="card"><div className="card-header py-2">Puntos existentes</div>
              <div className="card-body p-2" style={{ maxHeight: 350, overflow: 'auto' }}>
                {existing.length === 0 && <div className="text-muted small">No hay puntos</div>}
                {existing.length > 0 && (
                  <div className="d-flex gap-2 text-muted small mb-1">
                    <div className="flex-fill">Nombre</div>
                    <div style={{ width: 90 }}>Alias</div>
                    <div style={{ width: 80 }}>Radio</div>
                    <div style={{ width: 70 }}>Orden</div>
                  </div>
                )}
                {existing.map(p => (
                  <div key={p.id} className="border rounded p-2 mb-2">
                    <div className="d-flex gap-2 mb-1">
                      <input className="form-control form-control-sm" placeholder="Nombre" title="Nombre" value={p.name} onChange={e => setExisting(prev => prev.map(x => x.id === p.id ? { ...x, name: e.target.value } : x))} />
                      <input className="form-control form-control-sm" style={{ width: 90 }} placeholder="Alias" title="Alias" value={p.location} onChange={e => setExisting(prev => prev.map(x => x.id === p.id ? { ...x, location: e.target.value } : x))} />
                      <input type="number" min={1} step={1} className="form-control form-control-sm" style={{ width: 80 }} placeholder="Radio (m)" title="Radio (m)" value={p.geozoneRadio} onChange={e => setExisting(prev => prev.map(x => x.id === p.id ? { ...x, geozoneRadio: e.target.value } : x))} />
                      <input type="number" step={1} className="form-control form-control-sm" style={{ width: 70 }} placeholder="Orden" title="Orden" value={p.order ?? ''} onChange={e => setExisting(prev => prev.map(x => x.id === p.id ? { ...x, order: e.target.value } : x))} />
                    </div>
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                      <small className="text-muted">{Number(p.latitude).toFixed(6)}, {Number(p.longitude).toFixed(6)}</small>
                      <div className="d-flex gap-2 ms-auto">
                        {editingPointId === p.id ? (
                          <>
                            <button className="btn btn-sm btn-success" onClick={() => { saveExisting(p); setEditingPointId(null); }}><i className="bi bi-save" /> Guardar posición</button>
                            <button className="btn btn-sm btn-secondary" onClick={() => setEditingPointId(null)}>Cancelar</button>
                          </>
                        ) : (
                          <>
                            <button className="btn btn-sm btn-outline-warning" onClick={() => setEditingPointId(p.id)}><i className="bi bi-arrows-move" /> Posición</button>
                            <button className="btn btn-sm btn-outline-danger" onClick={() => deleteExisting(p.id)} title="Eliminar"><i className="bi bi-trash" /> Eliminar</button>
                            <button className="btn btn-sm btn-outline-primary" onClick={() => saveExisting(p)}><i className="bi bi-save" /> Guardar</button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div></div>
        <div className="modal-footer"><button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button></div>
      </div></div>
    </div>
  );
}
